module.exports = __webpack_public_path__ + "static/landing-cover-297471db8c58265813aaad08cae845c9.mp4";